import React from 'react';
import { Dropdown } from 'react-bootstrap';

interface IMultiSelectOption {
    value: string;
    label: string;
    image?: string;
}

interface IMultiSelectDropdown {
    placeholder: string;
    options: IMultiSelectOption[];
    selected: string[];
    onChange: (selected: string[]) => void;
    disabled?: boolean;
}

export default function MultiSelectDropdown({
    placeholder,
    options,
    selected,
    onChange,
    disabled = false,
}: IMultiSelectDropdown) {
    const toggle = (value: string) =>
        onChange(selected.includes(value) ? selected.filter(item => item !== value) : [...selected, value]);

    const selectedOptions = options.filter(option => selected.includes(option.value));
    const renderImage = (option: IMultiSelectOption) =>
        option.image ? <img src={option.image} alt={option.label} width={20} className="rounded-1" /> : null;

    const title =
        selected.length === 0
            ? placeholder
            : selected.length <= 2
            ? selectedOptions.map(option => (
                  <span key={option.value} className="d-inline-flex align-items-center gap-2">
                      {renderImage(option)}
                      {option.label}
                  </span>
              ))
            : `${selected.length} selected`;

    return (
        <Dropdown autoClose="outside">
            <Dropdown.Toggle
                variant=""
                disabled={disabled}
                className={`w-100 text-start border bg-white fs-7 ps-2 pe-2 d-flex align-items-center ${
                    selected.length ? 'border-primary' : ''
                }`}
                style={{ color: selected.length ? undefined : '#6c757d' }}
            >
                <span className="d-inline-flex align-items-center gap-3 flex-grow-1 text-truncate">{title}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100 py-1 fs-7" style={{ maxHeight: 300, overflowY: 'auto' }}>
                {options.map(option => (
                    <Dropdown.Item
                        key={option.value}
                        as="button"
                        type="button"
                        className={`py-1 px-2 d-flex align-items-center gap-2 ${
                            selected.includes(option.value) ? 'bg-primary-subtle text-primary' : ''
                        }`}
                        onClick={() => toggle(option.value)}
                    >
                        {renderImage(option)}
                        {option.label}
                    </Dropdown.Item>
                ))}
                {selected.length > 0 && (
                    <Dropdown.Item as="button" type="button" className="py-1 text-danger" onClick={() => onChange([])}>
                        Clear all
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
}
